<script lang="ts">
  import Section from '$components/common/Section.svelte';
  import ContentPageSubtitle from '$components/common/ContentPageSubtitle.svelte';
  import { contactEmail } from '$lib/utils/constants';
</script>

<svelte:head>
  <title>Conditions générales d'utilisation - Boris</title>
  <meta
    name="description"
    content="Consultez les conditions générales d'utilisation du site Boris, plateforme officielle dédiée au Bail Réel Solidaire, régissant l'accès et l'utilisation des services en ligne." />
</svelte:head>

<Section
  title="Conditions générales d'utilisation"
  titleElement="h1">
  <p>
    Bienvenue sur BoRiS, une plateforme en ligne fournie par le Ministère chargé
    du Logement. En accédant ou en utilisant notre site web, vous acceptez les
    termes et conditions énoncés ci-dessous.
  </p>

  <ContentPageSubtitle title="Présentation de la plateforme" />
  <p>
    BoRiS est la plateforme officielle d’information sur le dispositif relatif
    aux <a
      href="/organismes-de-foncier-solidaire"
      class="fr-link">
      organismes de foncier solidaire (OFS)
    </a>
    et au Bail Réel Solidaire. Cette plateforme s’adresse en premier lieu aux particuliers
    qui souhaitent en apprendre plus sur l’acquisition d’un logement en Bail Réel
    Solidaire. Il est possible pour ces particuliers de vérifier leur éligibilité
    au dispositif et de s’informer à chaque étape de leur projet. Enfin, avec cette
    plateforme, l’Etat se place comme tiers de confiance entre les ménages et les
    <a
      href="/organismes-de-foncier-solidaire"
      class="fr-link">
      organismes de foncier solidaire (OFS)
    </a>
    et facilite leur mise en relation.
  </p>

  <ContentPageSubtitle title="Qualité des informations publiées" />
  <p>
    Nous donnons accès sur BoRiS à des informations publiques. Cependant, seules
    les publications légales font foi, notamment au Journal officiel de la
    République française ou aux recueils des actes administratifs des
    préfectures.
  </p>
  <p>
    Par conséquent, les données accessibles sur le Site ne sauraient engager la
    responsabilité de leur éditeur ou d’un quelconque service de l’État,
    l’utilisateur y ayant recours en ayant conscience des potentielles erreurs
    ou omissions qu’elles peuvent comporter.
  </p>
  <p>
    Nous nous efforçons de livrer des données de la meilleure qualité possible.
    Toutefois, malgré toute notre attention, elles peuvent encore comporter des
    erreurs ou omissions. Si vous constatez une erreur ou omission parmi ces
    données, nous vous invitons à nous la signaler par courriel à l’adresse
    {contactEmail}.
  </p>

  <ContentPageSubtitle title="Propriété intellectuelle" />
  <p>
    Ce site est la propriété exclusive du Ministère chargé du Logement. Toute
    reproduction ou représentation, qu'elle soit totale ou partielle, de ce site
    sans l'autorisation expresse du propriétaire est strictement interdite et
    constituerait une violation des dispositions de l’article L. 335-2 du Code
    de la propriété intellectuelle.
  </p>
  <p>
    Si vous souhaitez reproduire ou réutiliser des contenus présents sur ce
    site, veuillez nous contacter à l'adresse {contactEmail} afin de connaître les
    conditions de réutilisation applicables. Les marques détenues par le ministère,
    ainsi que ses logos présents sur le site, sont des marques déposées auprès de
    l'Institut national de la propriété industrielle (INPI).
  </p>
  <p>
    Toute reproduction totale ou partielle, effectuée à partir des éléments du
    site sans l'autorisation expresse du propriétaire, est rigoureusement
    interdite en vertu des articles L. 713-2 et suivants du Code de la propriété
    intellectuelle. Tout contrevenant s'expose aux sanctions prévues par les
    articles L. 716-1 et suivants du code de la propriété intellectuelle.
  </p>

  <ContentPageSubtitle title="Limitation de la responsabilité" />
  <p>
    BoRiS ne saurait être tenu responsable des éventuelles difficultés de
    fonctionnement du service, ni être engagé directement ou indirectement
    vis-à-vis des utilisateurs pour tout incident tenant au fonctionnement de
    service.
  </p>
  <p>
    Nous nous engageons à protéger vos données, toutefois cet engagement ne
    saurait être assimilé à une reconnaissance de faute ou de responsabilité en
    cas d’incident relatif à une faille de sécurité.
  </p>

  <ContentPageSubtitle title="Disponibilité du site" />
  <p>
    Le ministère peut suspendre l’accès à BoRiS sans information préalable ni
    préavis, notamment pour des raisons de maintenance. Le ministère met
    l’application à jour régulièrement.
  </p>
</Section>
